import { action, thunk } from 'easy-peasy';
import getUser from '../services/User';

const UserModel = {
  first_name: '',
  last_name: '',
  stripe_id: '',
  email: '',
  is_admin: false,
  timzeone: '',

  showUser: action((state, user) => {
    state.first_name = user.first_name;
    state.last_name = user.last_name;
    state.stripe_id = user.stripe_id;
    state.email = user.email;
    state.is_admin = user.is_admin;
    state.timezone = user.timezone;
  }),

  getUser: thunk(async (actions) => {
    let user = await getUser();
    actions.showUser(user);
  })
};

export default UserModel;
